<template>
  <!-- 主页 -->
  <div class="mineHeader">
    <!-- 首页样式 -->
    <div v-show="windowWidth > 950">
      <div
        class="header"
        v-show="activeIndex == '1'"
        :class="titleType == 0 ? 'header0' : 'header1'"
      >
        <div
          class="headerMain"
          :class="titleType == 0 ? 'tabMove2' : 'tabMove'"
        >
          <router-link to="/home">
            <img
              :src="
                titleType == 0
                  ? picUrl + '/img/logo1.png'
                  : picUrl + '/img/logo2.png'
              "
              alt=""
              class="headerImg"
              @click="gotoHome"
            />
          </router-link>

          <el-menu
            v-if="titleType == 0"
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="rgba(0,0,0,0.4)"
            text-color="#fff"
            active-text-color="#589ef8"
          >
            <!-- menu-trigger=click	         -->
            <el-menu-item index="1">
              <template slot="title">首页</template>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">关于大蔚</template>
              <el-menu-item index="2-1">公司简介</el-menu-item>
              <el-menu-item index="2-2">企业实力</el-menu-item>
              <el-menu-item index="2-3">核心成员</el-menu-item>
              <el-menu-item index="2-4">荣誉资质</el-menu-item>
              <el-menu-item index="2-5">企业文化</el-menu-item>
              <el-menu-item index="2-6">大事记</el-menu-item>
              <el-menu-item index="2-7">团队风采</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">解决方案</template>
              <el-menu-item index="3-1">前端分类</el-menu-item>
              <el-menu-item index="3-2">易腐处理</el-menu-item>
              <el-menu-item index="3-3">资源利用</el-menu-item>
              <el-menu-item index="3-4">数字赋能</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">项目案例</template>
              <el-menu-item index="4-1">前端分类案例</el-menu-item>
              <el-menu-item index="4-2">易腐处理案例</el-menu-item>
              <el-menu-item index="4-3">资源利用案例</el-menu-item>
              <el-menu-item index="4-3">数字赋能案例</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">{{ tabData.title }}</template>
              <el-menu-item
                v-for="item in tabData.children"
                :key="item.id"
                :index="5 + '-' + item.id"
                >{{ item.title }}</el-menu-item
              >
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">联系我们</template>
              <el-menu-item index="6-1">联系方式</el-menu-item>
              <el-menu-item index="6-2">在线留言</el-menu-item>
            </el-submenu>
            <el-menu-item index="7">人才中心</el-menu-item>
            <el-menu-item index="8">友情链接</el-menu-item>
          </el-menu>

          <!-- 非首页 -->
          <el-menu
            v-if="titleType == 1"
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#f7f7f7"
            text-color="#909399"
            active-text-color="#589EF8"
          >
            <!-- menu-trigger=click	         -->
            <el-menu-item index="1">
              <template slot="title">首页</template>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">关于大蔚</template>
              <el-menu-item index="2-1">公司简介</el-menu-item>
              <el-menu-item index="2-2">企业实力</el-menu-item>
              <el-menu-item index="2-3">核心成员</el-menu-item>
              <el-menu-item index="2-4">荣誉资质</el-menu-item>
              <el-menu-item index="2-5">企业文化</el-menu-item>
              <el-menu-item index="2-6">大事记</el-menu-item>
              <el-menu-item index="2-7">团队风采</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">解决方案</template>
              <el-menu-item index="3-1">前端分类</el-menu-item>
              <el-menu-item index="3-2">易腐处理</el-menu-item>
              <el-menu-item index="3-3">资源利用</el-menu-item>
              <el-menu-item index="3-4">数字赋能</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">项目案例</template>
              <el-menu-item index="4-1">前端分类案例</el-menu-item>
              <el-menu-item index="4-2">易腐处理案例</el-menu-item>
              <el-menu-item index="4-3">资源利用案例</el-menu-item>
              <el-menu-item index="4-3">数字赋能案例</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">{{ tabData.title }}</template>
              <el-menu-item
                v-for="item in tabData.children"
                :key="item.id"
                :index="5 + '-' + item.id"
                >{{ item.title }}</el-menu-item
              >
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">联系我们</template>
              <el-menu-item index="6-1">联系方式</el-menu-item>
              <el-menu-item index="6-2">在线留言</el-menu-item>
            </el-submenu>
            <el-menu-item index="7">人才中心</el-menu-item>
            <el-menu-item index="8">友情链接</el-menu-item>
          </el-menu>
        </div>
      </div>
      <!-- 非首页样式 -->
      <div class="header header1" v-show="activeIndex !== '1'">
        <div class="headerMain tabMove">
          <router-link to="/home">
            <!-- <img
            src="../../public/img/logo2.png"
            alt=""
            class="headerImg"
          /> -->
            <div class="headerImg headerBg2"></div>
          </router-link>

          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#f7f7f7"
            text-color="#909399"
            active-text-color="#589EF8"
          >
            <!-- menu-trigger=click	         -->
            <el-menu-item index="1">
              <template slot="title" index="1-0">首页</template>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title" index="2-0">关于大蔚</template>
              <el-menu-item index="2-1">公司简介</el-menu-item>
              <el-menu-item index="2-2">企业实力</el-menu-item>
              <el-menu-item index="2-3">核心成员</el-menu-item>
              <el-menu-item index="2-4">荣誉资质</el-menu-item>
              <el-menu-item index="2-5">企业文化</el-menu-item>
              <el-menu-item index="2-6">大事记</el-menu-item>
              <el-menu-item index="2-7">团队风采</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title" index="3-0">解决方案</template>
              <el-menu-item index="3-1">前端分类</el-menu-item>
              <el-menu-item index="3-2">易腐处理</el-menu-item>
              <el-menu-item index="3-3">资源利用</el-menu-item>
              <el-menu-item index="3-4">数字赋能</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">项目案例</template>
              <el-menu-item index="4-1">前端分类案例</el-menu-item>
              <el-menu-item index="4-2">易腐处理案例</el-menu-item>
              <el-menu-item index="4-3">资源利用案例</el-menu-item>
              <el-menu-item index="4-4">数字赋能案例</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">{{ tabData.title }}</template>
              <el-menu-item
                v-for="item in tabData.children"
                :key="item.id"
                :index="5 + '-' + item.id"
                >{{ item.title }}</el-menu-item
              >
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">联系我们</template>
              <el-menu-item index="6-1">联系方式</el-menu-item>
              <el-menu-item index="6-2">在线留言</el-menu-item>
            </el-submenu>
            <el-menu-item index="7">人才中心</el-menu-item>
            <el-menu-item index="8">友情链接</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <!-- 论windowWidth的宽度 小于910做侧边栏-->
    <div v-show="windowWidth < 950">
      <div class="header3">
        <div class="header3Img"></div>
        <div class="btn_openHeader" @click="drawer = true"></div>
        <!-- 抽屉详情 -->

        <el-drawer
          title=""
          size="63%"
          :visible.sync="drawer"
          :direction="direction"
          :append-to-body="true"
        >
          <!-- 侧边抽屉导航栏 -->
          <div class="bg_drawer">
            <ul class="ul_drawer">
              <li class="li_drawer">
                <div class="title_drawer">首页</div>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
              <li class="li_drawer">
                <div class="title_drawer"></div>
                <img src="" alt="" class="arr_title" />
                <ul>
                  <li></li>
                </ul>
              </li>
            </ul>
          </div>
        </el-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "../../src/components/eventbus.vue";
import { picUrl } from "@/config/env";
import { postPv } from "@/api/postPv";
export default {
  name: "mineheader",
  data() {
    return {
      //移动端
      windowWidth: 1000, //屏幕宽度
      timer: false,
      drawer: false,
      direction: "rtl",
      activeNames: ["1"],
      /////
      picUrl: "",
      arr: [
        "/home",
        "/aboutus",
        "/solution",
        "/projectcase",
        "/news",
        "/contactus",
        "/joinus",
        "/minelink",
      ],
      titleType: 0, //1为平时 0是首页初始状态
      activeIndex: "", //页面导航

      // 移动端二次修正
      titleArr: [
        { id: 1, name: "首页", path: "/home" },
        {
          id: 2,
          name: "关于大蔚",
          path: "/aboutus",
          child: [
            { id: 21, name: "公司简介", code: "2-1" },
            { id: 22, name: "核心成员", code: "2-2" },
            { id: 23, name: "公司简介", code: "2-3" },
            { id: 22, name: "公司简介", code: "2-4" },
            { id: 22, name: "公司简介", code: "2-5" },
            { id: 22, name: "公司简介", code: "2-6" },
          ],
        },
        {
          id: 3,
          name: "解决方案",
          path: "/solution",
          child: [
            { id: 31, name: "公司简介", code: "2-1" },
            { id: 32, name: "核心成员", code: "2-2" },
            { id: 33, name: "公司简介", code: "2-3" },
            { id: 34, name: "公司简介", code: "2-4" },
            { id: 35, name: "公司简介", code: "2-5" },
            { id: 36, name: "公司简介", code: "2-6" },
          ],
        },
        { id: 4, name: "项目案例", path: "/projectcase" },
        { id: 5, name: "新闻资讯", path: "/news" },
        { id: 6, name: "联系我们", path: "/contactus" },
        { id: 7, name: "人才中心", path: "/joinus" },
        { id: 8, name: "友情链接", path: "/minelink" },
      ],
      typeList: [
        [], //放一个空作为第一个首页
        ["2-1", "2-2", "2-3", "2-4", "2-5", "2-6", "2-7"],
        ["3-1", "3-2", "3-3", "3-4"],
        ["4-1", "4-2", "4-3", "4-4"],
        ["5-2", "5-3"],
        ["6-1", "6-2"],
        [],
        [],
      ],

      tabData: {},
    };
  },
  watch: {
    titleType(val) {
      // //console.log(val);
      this.titleType = val;
    },
    windowWidth(val) {
      return;
      // 监听屏幕宽度
    },
  },
  computed: {},
  created() {},
  components: { picUrl },
  mounted() {
    this.getDict();
    let that = this;
    //获取当前路由
    that.$nextTick(() => {
      this.picUrl = picUrl;
      let arr = this.arr;
      let path = this.$route.path;
      let index = arr.indexOf(path) + 1;
      index = index.toString();
      // //console.log(index);
      if (index == 1 || index == 7 || index == 8) {
        this.activeIndex = index;
      } else {
        this.activeIndex = index + "-1";
      }
      //进来时候 判断样式
      if (this.$route.path == "/home" || this.$route.path == "/") {
        // //console.log(this.$route.path);
        this.titleType = 0;
        window.addEventListener("scroll", this.handleScroll);
      } else {
        //根据当前路由来判断选择样式
        this.titleType = 1;
      }

      eventbus.$on("myfn", (res) => {
        if (res == "1" || res == "7" || res == "8") {
          this.activeIndex = res;
        } else {
          this.activeIndex = res + "-1";
        }
      });
    });
    //进来先赋值然后resize时候 再来一次
    return;
  },
  methods: {
    getDict() {
      postPv(
        "https://www.azureflying.com/api/blade-system/dict-biz/tree?code=DICT"
      )
        .then((res) => {
          let result = res.data;
          let arr = result.filter((item) => {
            return item.key == "1";
          });
          console.log(arr);
          this.tabData = arr[0];
        })
        .catch((err) => {});
    },
    handleClose() {},
    link() {
      //console.log(type);
    },
    gotoHome() {
      this.$router.push("/home");
      window.scroll(0, 0);
      this.activeIndex = 1;
    },
    //导航栏点击
    handleSelect(key, keyPath) {
      document.removeEventListener("scroll", this.handleScroll);
      let arr = this.arr;
      //配色判断
      let index = keyPath[0];
      if (index == 1) {
        this.titleType = 0;
        window.addEventListener("scroll", this.handleScroll);
        window.scroll(0, 0);
      } else {
        this.titleType = 1;
      }
      index == 1 ? (this.titleType = 0) : (this.titleType = 1);
      this.$router.push({ path: arr[index - 1], query: { keyPath: key } });
      // window.scroll(0, 0); //  <= 这个
      // return;

      let typeList = this.typeList;

      if (index == 1 || index == 7 || index == 8) {
        this.$nextTick(() => {
          document
            .getElementsByClassName("home")[0]
            .scrollIntoView({ block: "start", behavior: "smooth" });
        });
        this.activeIndex = index;
      } else {
        let typeIndex = typeList[parseInt(key) - 1].indexOf(keyPath[1]);
        this.$nextTick(() => {
          document.getElementsByClassName("position").length > 0
            ? document
                .getElementsByClassName("position")
                [typeIndex].scrollIntoView({
                  block: "start",
                  behavior: "smooth",
                })
            : "";
        });
        this.activeIndex = index + "-1";
      }

      //console.log('跳转后')
    },

    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //
      // //console.log(scrollTop)
      let mineheight = document.getElementsByClassName("bannar")[0]
        ? document.getElementsByClassName("bannar")[0].offsetHeight - 100
        : 0;

      let menu = document.getElementsByClassName("el-menu-item");

      //样式
      if (this.$route.path == "/home" || this.$route.path == "/") {
        // //console.log(this.$route.path);
        if (scrollTop < mineheight) {
          // //console.log("照常展示");
          this.titleType = 0;
        }
        if (scrollTop > mineheight) {
          // //console.log("该悬浮了");
          this.titleType = 1;
        }
      } else {
        //console.log("我是其他页");
        this.titleType = 1;
        return;
      }
    },
  },

  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.el-menu {
  background-color: transparent;
}
.el-menu-demo {
  float: right;
  padding-right: 18px;
  margin-top: 10px;
}
.headerImg {
  float: left;
  width: 138px;
  margin: 19px 0 19px 170px;
}
.headerBg2 {
  height: 43px;
  background: url("../../public/img/logo2.png") no-repeat;
  background-size: cover;
}
.header {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: white;
  box-shadow: 0 0 2px 2px rgb(0 0 0 / 10%);
}
.header0 {
  background: rgba(0, 0, 0, 0.1);
}
.header1 {
  background: #f7f7f7;
}
.headerMain {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.el-menu--popup {
  background: transparent;
}
.el-menu-item {
  background: transparent;
}

/* header0 */
.header0 .el-menu--horizontal > .el-menu-item.is-active {
  color: white;
}
.header1 .el-menu--horizontal > .el-menu-item.is-active {
  color: #f7f7f7;
}
/* 移动端导航栏 */
.header3 {
  width: 100%;
  height: 154px;
  background: #333333;
  box-shadow: 0px 13px 20px rgba(0, 0, 0, 0.39);
  position: relative;
}
.header3Img {
  position: absolute;
  left: 152px;
  top: 38px;
  width: 246px;
  height: 76px;
  background: url("../../public/img/logo1.png") no-repeat;
  background-size: cover;
}
.btn_openHeader {
  position: absolute;
  right: 62px;
  top: 26px;
  width: 102px;
  height: 102px;
  background: url("../../public/img/mobile/openHeader.png") no-repeat;
  background-size: cover;
}
</style>
